export const LIST_SERVICE_KEY_IN_SERVICES = 'List';
export const CUSTOM_LIST_SERVICE_KEY_IN_SERVICES = 'CustomList';
